import script from "./DatasetCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetCard.vue?vue&type=script&setup=true&lang=js"

import "./DatasetCard.vue?vue&type=style&index=0&id=5be7be8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be7be8a"]])

export default __exports__